import { render, staticRenderFns } from "./ReviewAiLimitButton.vue?vue&type=template&id=7fac1689&scoped=true&"
import script from "./ReviewAiLimitButton.vue?vue&type=script&lang=js&"
export * from "./ReviewAiLimitButton.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAiLimitButton.vue?vue&type=style&index=0&id=7fac1689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac1689",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
